import { useLazyLoadQuery } from "react-relay"
import { fetchQuery, graphql } from "relay-runtime"
import { chTimeWindowFragment$data } from "@/modules/patients/fragments/ch/__generated__/chTimeWindowFragment.graphql"
import { usePatientAgendaChQuery } from "@/modules/patients/services/__generated__/usePatientAgendaChQuery.graphql"
import { usePatientAgendaDeQuery } from "@/modules/patients/services/__generated__/usePatientAgendaDeQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"
import { Country } from "@/types/__generated__/union-types"

export const chPatientAgendaQuery = graphql`
  query usePatientAgendaChQuery($patientId: ID!, $language: String!) {
    agendaData: ch_patientById(id: $patientId) {
      __typename
      appointments(first: null) @connection(key: "patientIdConnection_appointments") {
        edges {
          node {
            ...PatientAppointmentFragment @relay(mask: false)
          }
        }
      }
      timeWindows {
        ...chTimeWindowFragment @arguments(language: $language)
      }
      ch_alternativeTriages(first: null) @connection(key: "PatientByIdConnection_ch_alternativeTriages") {
        edges {
          node {
            ...chAlternativeTriageFragment @relay(mask: false)
          }
        }
      }
      externalAssistances(first: null) @connection(key: "PatientByIdConnection_externalAssistances") {
        edges {
          node {
            ...ExternalAssistanceFragment @relay(mask: false)
          }
        }
      }
    }
  }
`

const dePatientAgendaQuery = graphql`
  query usePatientAgendaDeQuery($patientId: ID!) {
    agendaData: de_patientById(id: $patientId) {
      __typename
      appointments(first: null) @connection(key: "patientIdConnection_appointments") {
        edges {
          node {
            ...PatientAppointmentFragment @relay(mask: false)
          }
        }
      }
      de_alternativeTriages(first: null) @connection(key: "PatientByIdConnection_de_alternativeTriages") {
        edges {
          node {
            ...deAlternativeTriageFragment @relay(mask: false)
          }
        }
      }
    }
  }
`

type ChBaseType = NonNullable<usePatientAgendaChQuery["response"]["agendaData"]>
type DeBaseType = NonNullable<usePatientAgendaDeQuery["response"]["agendaData"]>
export type TimeWindowsType = chTimeWindowFragment$data[number]
export type ChAlternativeTriageEdges = ChBaseType["ch_alternativeTriages"]
export type ChExternalAssistancesEdges = ChBaseType["externalAssistances"]
export type AppointmentEdges = ChBaseType["appointments"] | DeBaseType["appointments"]
export type DeAlternativeTriageEdges = DeBaseType["de_alternativeTriages"]

export const usePatientAgenda = (country: Country, patientId: string, language: string, fetchKey = 0) => {
  return useLazyLoadQuery<usePatientAgendaChQuery | usePatientAgendaDeQuery>(
    country === "CH" ? chPatientAgendaQuery : dePatientAgendaQuery,
    { patientId, language },
    { fetchKey },
  )
}

export const refetchChPatientAgenda = (patientId: string, language: string) => {
  return fetchQuery(RelayEnvironment, chPatientAgendaQuery, { patientId, language }).subscribe({})
}
